import React, { useRef } from 'react';
import AddressFields from '../../../area/booking/components/AddressFields';
import IAddress from '../interfaces/IAddress';

interface IProps {
    countries: string[];
    stateList: string[];
    address: IAddress;
    errors: {
        [key: string]: string;
    }
    handleChange(event: React.ChangeEvent<HTMLFormElement>): void;
    handleBlur(event: React.ChangeEvent<HTMLFormElement>): void;
    handleSelectChange(event: React.ChangeEvent<HTMLFormElement>): void;
}

const BillingAddress: React.FC<IProps> = ({
    countries,
    handleChange,
    handleBlur,
    handleSelectChange,
    errors,
    address,
    stateList
}) => {

    const inputRef = useRef<HTMLInputElement>(null);

    return (
        <div className="p-contributionForm">
            <fieldset className="c-form__fieldSet">
                <legend className="c-form__title box-title">Billing Address</legend>
                <AddressFields
                    inputRefs={inputRef}
                    formPrefix='billing'
                    countries={countries}
                    stateList={stateList}
                    userAddress={address}
                    onChange={handleChange}
                    selectChange={handleSelectChange}
                    onBlur={handleBlur}
                    errors={errors}
                />
            </fieldset>
        </div>
    );
};

export default BillingAddress;
